import React, { useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { useUpdateEffect } from 'react-use';
import {
  amber,
  blue,
  teal,
  green,
  lightGreen,
  lime,
  yellow,
  orange,
  deepOrange,
  brown,
  grey,
  blueGrey,
  indigo,
  deepPurple,
  purple,
  pink,
  red,
} from '@mui/material/colors';
import { alpha, darken, lighten } from '@mui/material';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
);

const AreaChart = ({ borderColor, textColor, data6 }) => {
  const [data, setData] = useState({
    labels: [],
    datasets: [],
  });
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: { ticks: { color: textColor }, grid: { color: borderColor } },
      y: {
        type: 'linear',
        display: true,
        ticks: { color: textColor, position: 'left' },
        grid: { color: borderColor },
      },
      y1: {
        type: 'linear',
        display: true,
        position: 'right',
        grid: {
          drawOnChartArea: false,
        },
        ticks: {
          color: blue[500],
          font: {
            size: 14,
            weight: 900,
          },
        },
      },
    },
  };

  const colorList = [
    amber,
    orange,
    deepOrange,
    brown,
    grey,
    blueGrey,
    indigo,
    teal,
    green,
    lightGreen,
    lime,
    deepPurple,
    purple,
    pink,
    red,
    yellow,
  ];

  useUpdateEffect(() => {
    if (data6 && 'labels' in data6 && data6.labels.length) {
      const { labels, datasets: ds } = data6;
      const datasets = Object.entries(ds)
        .map((item, i) => {
          const [label, { data: v }] = item;
          if (label === 'total') {
            return {
              label,
              data: v,
              borderColor: blue[500],
              backgroundColor: alpha(blue[500], 0.7),
              yAxisID: 'y1',
              fill: true,
            };
          }
          const color = colorList[`${i}`.length - 1];
          let alphaIdx = '100';
          if (i === 9) alphaIdx = '900';
          else if (i % 9 === 0) alphaIdx = 'A100';
          else alphaIdx = `${i % 9}00`;

          return {
            label,
            data: v,
            borderWidth: 2,
            borderDash: [5, 1],
            borderJoinStyle: 'round',
            borderColor: lighten(color[alphaIdx], 0.1),
            backgroundColor: darken(color[alphaIdx], 0.1),
            yAxisID: 'y',
          };
        })
        .reverse();

      setData({ labels, datasets });
    }
  }, [data6]);

  return (
    <Line
      options={options}
      data={data}
      onMouseDown={(e) => e.stopPropagation()}
    />
  );
};

export default AreaChart;
